import { useParams, useNavigate, useLocation } from "react-router-dom"; // 👈 ADDED useLocation
import { useState } from "react";
import { Tabs, Tab, Box, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import VendorInfo from "./VendorInfo";
import VendorMenu from "./VendorMenu";
import VendorOrders from "./VendorOrders";
// import VendorFinance from "./VendorFinance";

export default function VendorDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation(); // 👈 Access state
  const [tab, setTab] = useState(0);

  // 👇 NEW: Determine exactly where to go back to based on the state passed
  const handleBack = () => {
    if (location.state?.returnUrl) {
      navigate(location.state.returnUrl);
    } else {
      navigate(-1); // Fallback
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        minHeight: "100vh",
        bgcolor: "#FFFDF8",
        p: { xs: 2, sm: 3, md: 4 },
        pb: { xs: 15, sm: 8 },
        boxSizing: "border-box"
      }}
    >

      {/* MODERN BACK BUTTON & HEADER */}
      <Box display="flex" alignItems="center" gap={1.5} mb={4}>
        <IconButton
          onClick={handleBack} // 👈 UPDATED CLICK HANDLER
          sx={{
            bgcolor: '#FFFFFF',
            border: '1px solid #ECE5DA',
            color: '#3A2C23',
            boxShadow: '0 4px 8px rgba(0,0,0,0.04)',
            transition: 'all 0.2s ease',
            '&:hover': { bgcolor: '#F8C332', borderColor: '#F8C332', transform: 'translateY(-2px)' }
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h5" fontWeight="900" sx={{ color: "#3A2C23", letterSpacing: "-0.5px" }}>
          Vendor Details
        </Typography>
      </Box>

      {/* 3D FLOATING TABS CONTAINER */}
      <Box
        sx={{
          width: "100%",
          bgcolor: "#FFFFFF",
          borderRadius: "20px",
          p: 1,
          boxShadow: '0 10px 24px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          '&:hover': {
            transform: 'translateY(-3px)',
            boxShadow: '0 16px 32px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <Tabs
          value={tab}
          onChange={(e, val) => setTab(val)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            "& .MuiTabs-flexContainer": {
              gap: { xs: 1, sm: 1.5 }
            },
            "& .MuiTab-root": {
              fontWeight: "900",
              textTransform: "none",
              minWidth: "auto",
              px: { xs: 2.5, sm: 4 },
              py: 1.2,
              minHeight: "40px",
              fontSize: { xs: "0.85rem", sm: "0.95rem" },
              borderRadius: "14px",
              color: "#A59D96",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:hover": {
                color: "#3A2C23",
                bgcolor: "#FFFDF8"
              },
              "&.Mui-selected": {
                color: "#3A2C23",
                bgcolor: "#F8C332",
                boxShadow: "0 4px 12px rgba(248, 195, 50, 0.3)"
              }
            }
          }}
        >
          <Tab label="Details" />
          <Tab label="Menu" />
          <Tab label="Orders" />
          {/* <Tab label="Financial" /> */}
        </Tabs>
      </Box>

      {/* CONTENT AREA */}
      <Box sx={{ mt: 4, minWidth: 0 }}>
        {tab === 0 && <VendorInfo vendorId={id} />}
        {tab === 1 && <VendorMenu vendorId={id} />}
        {tab === 2 && <VendorOrders vendorId={id} />}
        {/* {tab === 3 && <VendorFinance vendorId={id} />} */}
      </Box>

    </Box>
  );
}